import { theme } from '../../../../ThemeContext/ThemeObject';

export const HEIGHT = 26;
export const MARGIN_BOTTOM = 6;
export const BORDER_HEIGHT = 2;

export const styles = {
  container: {
    transition: 'height 0.5s cubic-bezier(.75,.34,.19,.79)',
    overflow: 'hidden'
  },
  item: {
    backgroundColor: '#EDF2F5',
    color: theme.palette.primary.main,
    borderRadius: `${HEIGHT / 2}px`,
    height: HEIGHT,
    textAlign: 'center',
    fontWeight: '600',
    marginBottom: `${MARGIN_BOTTOM}px`,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    padding: '0 18px',
    border: `${BORDER_HEIGHT}px solid white`,
    zIndex: 1,
    lineHeight: `${HEIGHT - BORDER_HEIGHT * 2}px`,
    transition: 'width 0.5s cubic-bezier(.75,.34,.19,.79)',
    fontSize: '13px'
  },
  viewAllItem: {
    overflow: 'unset',
    textOverflow: 'unset',
    whiteSpace: 'unset',
    height: 'unset',
    lineHeight: 'unset'
  },
  badge: {
    backgroundColor: '#EDF2F5',
    color: theme.palette.primary.main,
    borderRadius: HEIGHT / 2,
    height: HEIGHT,
    border: `${BORDER_HEIGHT}px solid white`,
    textAlign: 'center',
    fontWeight: '600',
    minWidth: '38px',
    transform: 'translateX(-13px)',
    marginRight: '-13px',
    paddingLeft: '8px',
    userSelect: 'none',
    lineHeight: `${HEIGHT - BORDER_HEIGHT * 2}px`,
    transition: 'opacity 0.5s, width 0.5s cubic-bezier(.75,.34,.19,.79)',
    cursor: 'pointer'
  },
  showLess: {
    fontSize: '12px',
    cursor: 'pointer',
    userSelect: 'none',
    width: '100px',
    margin: 'auto'
  }
};
